import React, { useState, useEffect } from "react";
import content from "./json/content.json";
import i18next from 'i18next';
import { useTranslation } from "react-i18next";

export default function GettingStarted() {
  const [contentdata, setcontentdata] = useState([]);
  const [allLanguage, setAllLanguage] = useState("english");
  const { t } = useTranslation();

  useEffect(() => {
    setcontentdata(content[allLanguage === "english" ? 'en' : 'fr'].gettingstarted);
  }, [allLanguage]);

  // Set language according current local
  useEffect(() => {
    i18next.changeLanguage(navigator.language === 'en-US' ? 'en' : 'fr'); // Change the i18next language
    localStorage.setItem("handleSelectedLanguage", navigator.language === 'en-US' ? 'english' : 'guinea');
  }, [navigator.language]);

  // Get handleSelectedLanguage from localStorage
  useEffect(() => {
    const storeHandleSelectedLanguage = localStorage.getItem('handleSelectedLanguage');
    if (storeHandleSelectedLanguage) {
      setAllLanguage(storeHandleSelectedLanguage); // Update state
    }
  }, [localStorage.getItem('handleSelectedLanguage')]); // Runs only on mount

  return (
    <div className="mt-5">
      {contentdata.map((itemdata, index) => {
        return (
          <div key={index}>
            <h4 className="h4-heading">{itemdata.titlename}</h4>
            {itemdata.pracontent.map((para, index) => (
              <p key={index} className="p-pera">
                {para}
              </p>
            ))}
            <div >
              <h5 className="h5-heading">{itemdata.titlename2}</h5>
              {itemdata.pracontent2.map((para, index) => (
                <p key={index} className="p-pera">
                  {para}
                </p>
              ))}

              <h5 className="h5-heading">{t("main.developerDocuments.How_to_use")}</h5>
              <ul>
                <li className="mt-3">
                  <strong>{t("main.developerDocuments.Register_a_New_Merchant")}</strong>
                  <p className="p-pera">
                    {t("main.developerDocuments.Use_the_onboarding_API_to_initiate_paragraph")}
                  </p>
                </li>

                <li className="mt-3">
                  <strong>{t("main.developerDocuments.Upload_Required_Documents")}</strong>
                  <p className="p-pera">
                    {t("main.developerDocuments.The_merchant_must_upload_the_necessary_documents")}:
                  </p>
                  <ol className="order-list-ind">
                    <li className="p-pera">{t("main.developerDocuments.Base64_encoded_strings")}</li>
                    <li className="p-pera">{t("main.developerDocuments.Multipart_form_data")}</li>
                    <strong className="mt-4">{t("main.developerDocuments.Required_documents")}:</strong>
                    <ul className="mb-3">
                      <li className="p-pera">{t("main.developerDocuments.National_ID_card")}</li>
                      <li className="p-pera">{t("main.developerDocuments.Tax_Identification_Number")}</li>
                      <li className="p-pera">{t("main.developerDocuments.Latest_Bank_Statement")}</li>
                    </ul>
                  </ol>
                </li>
                <li className="mt-3">
                  <strong>{t("main.developerDocuments.Verify_and_Submit")}</strong>
                  <p className="p-pera">{t("main.developerDocuments.Once_all_data_and_documents_are_submitted")}:</p>
                  <ol className="order-list-ind">
                    <li className="p-pera">{t("main.developerDocuments.Background_checks")}</li>
                    <li className="p-pera">{t("main.developerDocuments.Compliance_validation")}</li>
                  </ol>
                </li>
                <li className="mt-3">
                  <strong>{t("main.developerDocuments.Status_Updates")}</strong>
                  <p className="p-pera">{t("main.developerDocuments.You_will_receive_onboarding_status")}</p>
                </li>
                <li className="mt-3">
                  <strong>{t("main.developerDocuments.Go_Live")}</strong>
                  <p className="p-pera">{t("main.developerDocuments.Once_the_merchant_is_verified")}</p>
                </li>
              </ul>
            </div>
            <div>
              <h5 className="h5-heading">{itemdata.titlename3}</h5>
              {itemdata.pracontent3.map((para, index) => (
                <p key={index} className="p-pera">
                  {para}
                </p>
              ))}
              {itemdata.pracontent4.map((para, index) => (
                <p key={index} className="p-pera">
                  {para}
                </p>
              ))}
              <ol className="order-list-ind">
                <li>{t("main.developerDocuments.Live_Key")}</li>
                <li>{t("main.developerDocuments.Demo_Key")}</li>
              </ol>
              <h5 className="h5-heading">{t("main.developerDocuments.Types_of_API_Keys")}</h5>
              <p className="error-heading-pra ">{t("main.developerDocuments.Publishable_Key")}</p>
              <ol className="order-list-ind">
                {itemdata.listpra.map((para, index) => {
                  return (
                    <li key={index} className="p-pera">
                      {para}
                    </li>
                  );
                })}
              </ol>

              <p className="error-heading-pra">{t("main.developerDocuments.Secret_Key")}</p>
              <ol className="order-list-ind">
                {itemdata.listpra1.map((para, index) => {
                  return (
                    <li key={index} className="p-pera">
                      {para}
                    </li>
                  );
                })}
              </ol>
            </div>
          </div>
        );
      }, [])}
    </div>
  );
}
